export const matchTypeValues = ['include', 'exactMatch', 'regex'] as const

export type MatchType = (typeof matchTypeValues)[number]
